(() => {

  /**
   * Collection Scroll Memory
   *
   * @description Maintains scroll position and pagination state across page refreshes
   * for collection grid pages.
   *
   * @requires Each pagination boundary in the collection grid must be marked with
   * the [data-pagination-start] attribute. The first product card of each pagination
   * page should have this attribute with the page number as its value.
   *
   * @example
   * <div class="product-grid">
   *   <li data-pagination-start="1">Product 1</li>
   *   <li>Product 2</li>
   *   <li>Product 3</li>
   *   <li>Product 4</li>
   *   <li data-pagination-start="2">Product 5</li>
   *   <li>Product 6</li>
   *   <li>Product 7</li>
   *   <li>Product 8</li>
   *   <li>Product 9</li>
   *   <li>Product 10</li>
   * </div>
   */

  window.selectedCollectionSwatches = window.selectedCollectionSwatches || [] // Keep track of user selected swatches for the collection

  const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
  const eventName = !!iOS ? "pagehide" : "beforeunload"

  function goToPreviousScrollPosition(){
    // If this should only run on iOS devices, un-comment the line below
    //if(!iOS) return
    if(!sessionStorage.getItem('collectionScroll')) return
    const collectionScroll = JSON.parse(sessionStorage.getItem('collectionScroll'))
    if(window.location.href !== collectionScroll.url) return

    window.scrollTo(0, collectionScroll.scrollPosition)

    document.querySelector('body').style.opacity = 1

    if(collectionScroll.page == 1) return

    let previousPage = collectionScroll.page - 1
    if(previousPage <= 0) {
      document.querySelector('.load-previous')?.remove()
      return
    }

    // Inject Load Previous button
    const productGrid = document.querySelector('#product-grid')
    if (productGrid) {
      document.querySelector('.load-previous')?.remove()
      productGrid.insertAdjacentHTML(
        'beforebegin',
        `<button class="link load-previous" data-url="${collectionScroll.url.split("?")[0]}?page=${previousPage}">
          <span>Load previous</span>
          <svg
            aria-hidden="true"
            focusable="false"
            class="spinner"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </button>`
      )
      attachLoadPreviousListener()
    }

  }

  window.addEventListener(eventName, () => {
    // data-scroll-y scroll position stored before body was position: fixed
    let currentScrollPos = parseInt(document.body.dataset.scrollY) || window.scrollY

    let pageNumber = 1

    // Determine what page we are currently scrolling on using [data-pagination-start] attributes
    const paginationElements = document.querySelectorAll('[data-pagination-start]')
    if (paginationElements.length > 0) {
      paginationElements.forEach((element) => {
        const elementTop = element.offsetTop
        if(window.scrollY >= elementTop) {
          pageNumber = parseInt(element.getAttribute('data-pagination-start'))
        }
      })
    }

    if(pageNumber != 1) {  // User is page greater than 1
      // determine what page is loaded, and where the page content start
      const startOfAppendedPage = document.querySelector(`[data-pagination-start="${pageNumber}"]`)
      if(startOfAppendedPage) {
        currentScrollPos = currentScrollPos - startOfAppendedPage.offsetTop
      }
    }

    // create url with current page number
    let currentURL = new URL(window.location.href)
    currentURL.searchParams.set("page", pageNumber)
    const savedURL = currentURL.toString()

    // update window url
    history.replaceState({}, '', savedURL);

    const collectionScroll = JSON.parse(sessionStorage.getItem('collectionScroll'))
    if(collectionScroll && window.location.href === collectionScroll.url && collectionScroll.selectedSwatches.length > 0) {
      window.selectedCollectionSwatches = [...collectionScroll.selectedSwatches, ...window.selectedCollectionSwatches]
    }

    sessionStorage.setItem('collectionScroll',
      JSON.stringify({
        "scrollPosition": currentScrollPos,
        "url": savedURL,
        "page": (pageNumber) ? pageNumber : 1,
        "selectedSwatches": window.selectedCollectionSwatches
      })
    )
  })

  function attachLoadPreviousListener() {
    const loadPreviousBtn = document.querySelector('.load-previous')

    if(!loadPreviousBtn) return

    loadPreviousBtn.addEventListener('click', function(event) {
      event.preventDefault()
      const url = loadPreviousBtn.getAttribute('data-url')

      if (!url) return

      loadPreviousBtn.classList.add('loading')

      const pageNumber = url.split('page=')[1] ? url.split('page=')[1] : 1

      window.history.replaceState({}, '', url)

      // Fetch the previous page
      fetch(url)
        .then(res => res.text())
        .then(res => {
          // Parse the response as HTML
          const parser = new DOMParser()
          const doc = parser.parseFromString(res, 'text/html')

          const targetGrid = document.querySelector('.product-grid')

          // Get the original scroll position
          const originalScrollTop = window.scrollY;

          // Get the original height of the product grid
          const originalHeight = targetGrid?.offsetHeight

          // add a data attribute marking start of pagination in the new grid items
          doc.querySelector('.product-grid').querySelector('.grid__item')?.setAttribute('data-pagination-start',pageNumber)

          // append previous page grid items to current grid items
          const items = doc.querySelector('.product-grid').innerHTML
          targetGrid.insertAdjacentHTML('afterbegin', new DOMParser().parseFromString(items, 'text/html').body.innerHTML);

          // Get the new height of the product grid
          const newHeight = targetGrid?.offsetHeight
          if(newHeight && originalHeight){
            // Calculate the difference between the new and original height
            const heightDifference = newHeight - originalHeight;
            if(heightDifference > 0){
              // Scroll to the new position
              const newScrollTop = originalScrollTop + heightDifference;
              window.scrollTo({ top: newScrollTop, behavior: 'instant' });
            }
          }

          // lazyload any videos that loaded in the grid
          if(typeof lazyLoadPLPVideos !== 'undefined'){
            lazyLoadPLPVideos()
          }

          // Check if we still have more previous pages
          if(pageNumber - 1 > 0){
            // Update load previous page
            loadPreviousBtn.setAttribute('data-url',url.replace(`page=${pageNumber}`,`page=${pageNumber - 1}`))
            loadPreviousBtn.classList.remove('loading')
            attachLoadPreviousIntersectionListener(loadPreviousBtn)
          } else {
            loadPreviousBtn?.remove()
          }

        })
        .catch(err => console.log(err))
    })

    attachLoadPreviousIntersectionListener(loadPreviousBtn)

  }

  function attachLoadPreviousIntersectionListener(loadPreviousBtn) {
    if (loadPreviousBtn) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadPreviousBtn.click();
            observer.unobserve(loadPreviousBtn); // Stop observing after clicking
          }
        });
      });
      observer.observe(loadPreviousBtn);
    }
  }

  if(iOS){
    goToPreviousScrollPosition()
  } else {
    // disable default browser scroll restoration when not on iOS
    if (history.scrollRestoration)  history.scrollRestoration = "manual";

    // restore desktop scroll on document ready
    function docReady(fn) {
      if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1);
      } else {
        document.addEventListener("DOMContentLoaded", fn);
      }
    }
    docReady(function() {
      goToPreviousScrollPosition()
    });
  }

})()